import React, {Component} from 'react'
import { Videos } from './../../../../../components'

export default class VideoTemplate extends Component {
  render () {
    return (
      <Videos {...this.props}/>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/VideoTemplate.js